<h3 class="ui primary header">
    {{ modal.context.title }}
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content create-alert-form">
    <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
        <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            <esl-message-toast [(message)]="error"></esl-message-toast>
        </div>
        <div class="section-holder">
            <div class="header-text">SIMULTANEOUS FILE UPLOAD PER USER SESSION</div>
            <div class="header-bottom-text">{{ data?.count }}</div>
        </div>

        <div class="section-holder">
            <div class="header-text">CREATED BY</div>
            <div class="header-bottom-text">{{ data?.createdBy | createdBy }}</div>
        </div>

        <div class="section-holder">
            <div class="header-text">DATE BY</div>
            <div class="header-bottom-text">{{ data?.dateCreated | date : 'medium' }}</div>
        </div>

        <div class="section-holder">
            <div class="header-text">LAST UPDATED</div>
            <div class="header-bottom-text">{{ data?.dateModified | date : 'medium' }}</div>
        </div>

        <div class="section-holder">
            <div class="header-text">LAST UPDATED BY</div>
            <div class="header-bottom-text">{{ data?.modifiedBy | createdBy }}</div>
        </div>
    </div>
</div>

<div class="actions" style="border: none; background-color: #fff">
    <button class="ui button cancel-modal" (click)="modal.deny(undefined)">
        Cancel
    </button>
</div>